import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgFemaleGlyphSecondary from './svgs/FemaleGlyphSecondary.js';
import SvgFemaleGlyph from './svgs/FemaleGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var femaleGlyph = (props => useIcon(SvgFemaleGlyph, SvgFemaleGlyphSecondary, props));

export { femaleGlyph as default };
